/* Sentry error tracking initialization.
   Must be called before React renders (in main.tsx). */

import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.warn("VITE_SENTRY_DSN is not set — Sentry disabled.");
    return;
  }

  const isProduction = import.meta.env.PROD;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "unknown",

    integrations: [Sentry.browserTracingIntegration()],

    tracesSampleRate: isProduction ? 0.1 : 1.0,

    replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*\.convex\.cloud/,
      /^https:\/\/.*\.convex\.site/,
    ],

    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value || "";
      if (message.includes("Could not find public function")) return null;
      if (message.includes("Failed to fetch")) return null;
      if (message.includes("Network request failed")) return null;
      return event;
    },
  });
}

export function setSentryUser(userId: string, email?: string) {
  Sentry.setUser({ id: userId, email });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export { Sentry };
